/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

class SaveInlineService implements ISaveInlineService {
    public static $inject = [];

    constructor() {

    }

    public saveChange(params: any): void {
    }
}

angular.module('beneple.global')
    .service('SaveInlineService', SaveInlineService);



// WEBPACK FOOTER //
// ./frontend/scripts/global/services/save_inline.service.ts